module.exports = __webpack_public_path__ + "media/images/redesign-images/how-it-works/icons/icon-bag-tag-63ab79a937815842a9309f9e30b613ab.svg";